module.exports = __webpack_public_path__ + "img/hr-destroyer-robot-mask.b6c3bebe.png";